import { hiddenGems } from "@/mocks/comics";
import SectionHeader from "./SectionHeader";

export default function HiddenGems() {
  return (
    <section id="秘书严选" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="秘书严选"
          eyebrowTone="secondary"
          title={
            <>
              严选冷门佳作 <span className="text-secondary-700">· 不随大流的私藏</span>
            </>
          }
          subtitle="编辑部地毯式扫荡后留下的四部小众宝藏。它们可能没有惊人的热度，但每一部都值得被更多人读到。"
        />

        <div className="grid gap-6 md:grid-cols-2">
          {hiddenGems.map((comic, index) => (
            <article
              key={comic.id}
              className="group flex gap-5 overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-secondary-300 md:gap-6"
            >
              <div className="relative aspect-[3/4] w-32 shrink-0 overflow-hidden bg-background-200 sm:w-40">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 秘书严选冷门漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute -left-1 top-2 flex h-10 w-10 items-center justify-center bg-secondary-500 font-heading text-lg font-black text-background-50">
                  {index + 1}
                </span>
              </div>
              <div className="flex flex-1 flex-col py-4 pr-4 md:py-5 md:pr-6">
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-bold text-foreground-950 md:text-lg">{comic.title}</h3>
                  <span className="ml-auto flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-800">
                    {comic.rating}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">{comic.author} · {comic.genre}</p>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {comic.summary}
                </p>
                <p className="mt-auto pt-2 text-xs text-secondary-800">
                  <i className="ri-quill-pen-line mr-1" aria-hidden="true"></i>
                  {comic.note}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}